import { useTranslation } from 'react-i18next'

import { useInlineNotifications } from '../../../../hooks'
import { useCloseConfirm } from '../../../Form'
import { FormikForm } from '../../../Formik'
import { WidgetFormContainer } from '../../WidgetFormContainer'
import {
  getInfoWidgetInitialValues,
  getInfoWidgetPayload,
  getInfoWidgetValidationSchema,
} from '../ProfileInfoWidget.utils'

import { ProfileInfoWidgetFormFields } from './ProfileInfoWidgetFormFields'

function ProfileInfoWidgetForm({
  NotesField,
  config,
  data,
  options,
  onClose,
  onSubmit,
  onSuccess,
}) {
  const { t } = useTranslation()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const initialValues = getInfoWidgetInitialValues({ config, data })

  const validationSchema = getInfoWidgetValidationSchema({ config, t })

  function handleSubmit(values, formikHelpers) {
    const payload = getInfoWidgetPayload({
      blockName: data?.block_name,
      config,
      initialValues,
      values,
    })

    if (!payload) {
      formikHelpers.setSubmitting(false)
      onSuccess?.()

      return
    }

    return onSubmit(payload)
      .then(() => {
        onSuccess?.()
      })
      .finally(() => {
        formikHelpers.setSubmitting(false)
      })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{
        isCloseConfirm,
        setCloseConfirm,
        onClose,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <ProfileInfoWidgetFormFields
        NotesField={NotesField}
        config={config}
        notifications={notifications}
        options={options}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ProfileInfoWidgetForm
